import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const CITIES_CITY_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/cities',
        name: '::Menu:Cities',
        iconClass: 'fas fa-city',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Cities',
        parentName: '::Menu:Configurations',
        order: 1,
      },
    ]);
  };
}
